import { Button, CircularProgress } from '@mui/material';
import Box from '@mui/material/Box';
import { useLazyQuery } from '@parkchirp/api-client';
import { ReportType } from 'parkchirp-shared/enums';
import React, { FC, useState } from 'react';
import { GET_FACILITY_SETTINGS_REPORT } from '../../queries';
import type { SetShowSnackbar } from '../../types';

export const FacilitySettingsReportForm: FC<{
	facilityId: string;
	setShowSnackbar: SetShowSnackbar;
}> = ({ facilityId, setShowSnackbar }) => {
	const [isDownloadingCsv, setIsDownloadingCsv] = useState(false);
	const [getFacilitySettingsReport] = useLazyQuery(GET_FACILITY_SETTINGS_REPORT, {
		fetchPolicy: 'network-only',
	});
	const handleDownload = async (reportType: ReportType) => {
		if (reportType === ReportType.CSV) {
			setIsDownloadingCsv(true);
		}

		if (facilityId) {
			const { error } = await getFacilitySettingsReport({
				context: {
					apiVersion: 'v2',
					appName: process.env.NEXT_PUBLIC_APP_NAME,
				},
				variables: {
					facilityId,
					reportType,
				},
				onCompleted: (data: { getFacilitySettingsReport: { url: string } }) => {
					const fileLink = document.createElement('a');
					fileLink.href = data.getFacilitySettingsReport.url;
					fileLink.click();
				},
			});
			if (error) {
				setShowSnackbar({
					message: error.message,
					severity: 'error',
					onClose: () => {
						setShowSnackbar(null);
					},
				});
			}

			setIsDownloadingCsv(false);
		}
	};

	return (
		<Box sx={{ mt: 3 }}>
			<Button
				variant='contained'
				size='small'
				onClick={() => handleDownload(ReportType.CSV)}
				disabled={!facilityId || isDownloadingCsv}
				data-cy='download-csv-button'
			>
				{isDownloadingCsv ? <CircularProgress size={24} /> : 'Download CSV'}
			</Button>
		</Box>
	);
};
